<template>
  <div type="card-full" style="margin:20px 30px;">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">其它附件:</div>
              <div class="view-filelist" v-if="appendList && appendList.length">
                <div v-for="(item,index) in appendList" :key="index" class="view-fileitem">
                  <div class="view-filename" @click="downFile(item.appendurl, item.appendid)">
                    <a :src="uploadAddr + item.appendurl">{{item.appendfilename | toolongOmitted}}</a>
                  </div>
                  <div style="margin-left:30px">
                    {{item.comfullname}}
                  </div>
                </div>
              </div>
              <div v-else class="view-value">无</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import request from '@/utils/request'
  import common from '@/mixin/common'
  export default {
    name: 'pjConFile',
    mixins: [common],
    data () {
      return {
          appendList:[]
      }
    },
    filters:{
    },
    async created () {
      await this.getModel()
    },
    async mounted () {
      await this.getModel()
    },
    watch: {
      '$route.query.Ptype':async function(newVal,oldVal){
        if(newVal != oldVal){
          await this.getModel()
        }
      }
    },
    methods: {
      async getModel () {
          let res = await request({
            method:'get',
            url:'/xmgl/pds/getFileList',
            params:{projectid:this.$route.query.projectid, ptcid: this.$route.query.ptcid, pdsid: this.$route.query.pdsid}
          })
          this.appendList = res.otherList
      },
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    }
  }
</script>
<style lang="scss" scoped>
</style>
